export class CustomerSearchResultModel {
    customerNumber: any;
    customerTypeId: number;
    customerStatusTypeId: number;
    dateOfBirth: any;
    legacyCustomerNumber: string;
    customerName: string;
    displayAddress: string;
    legacySequenceNumber: string;
    credentialNumberDisplayValue: string;
    isBiometricRedacted: boolean;

    constructor(source?: Partial<CustomerSearchResultModel>) {
        Object.assign(this, source);
    }
}
